import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { ProjectErrorInterceptor } from './interceptors/project-error.interceptor';

@NgModule({
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        // Registered AFTER HttpErrorInterceptor so its error handler runs first and can
        // swallow project-processing errors before the generic 401/403 session-clear.
        { provide: HTTP_INTERCEPTORS, useClass: ProjectErrorInterceptor, multi: true }
    ],
    declarations: [],

    imports: [CommonModule]
})
export class SharedCoreModule {}
